const route = {
	path: '/configuration',
	name: 'page-configuration',
	meta: {
		title: 'Configuración',
	},
	redirect: '/configuration/dealers',
	component: () => import('@/pages/configuration/page-configuration'),
	children: [
		{
			name: 'page-config-dealers',
			path: 'dealers',
			meta: {
				title: 'Distribuidores',
				primary: true,
			},
			component: () => import('@/pages/configuration/page-list-configuration'),
			props: true,
			children: [
				{
					name: 'page-config-projects',
					path: ':id/projects',
					meta: {
						title: 'Proyectos',
					},
					component: () => import('@/pages/configuration/page-projects'),
					props: true,
				},
				{
					name: 'page-config-template',
					path: ':id/template',
					meta: {
						title: 'Template',
					},
					component: () => import('@/pages/configuration/page-template'),
					props: true,
				},
				{
					name: 'page-dealers-implementers',
					path: ':id/implementers',
					meta: {
						title: 'Implementadores',
					},
					component: () => import('@/pages/configuration/page-dealers-implementers'),
					props: true,
				},
				{
					name: 'page-dealers-resource',
					path: ':id/resource',
					meta: {
						title: 'Recursos',
					},
					component: () => import('@/pages/configuration/page-dealers-resource'),
					props: true,
				},
				{
					name: 'page-dealers-new',
					path: ':id?/new',
					meta: {
						title: 'Crear Usuario',
					},
					component: () => import('@/pages/configuration/page-config-create'),
					props: true,
				},
				{
					name: 'page-dealers-application',
					path: ':id/application',
					meta: {
						title: 'Aplicaciones',
					},
					component: () => import('@/pages/configuration/page-dealers-application'),
					props: true,
				},
			],
		},
		{
			name: 'page-config-implementers',
			path: 'implementers',
			meta: {
				title: 'Implementadores',
				primary: true,
			},
			component: () => import('@/pages/configuration/page-list-configuration'),
			props: true,
			children: [
				{
					name: 'page-implementers-company',
					path: ':id/company',
					props: true,
					meta: {
						title: 'Empresas',
					},
					component: () => import('@/pages/implementers/page-implementers-company'),
				},
				{
					name: 'page-implementers-create',
					path: ':id?/new',
					meta: {
						title: 'Crear Usuario',
					},
					component: () => import('@/pages/configuration/page-config-create'),
					props: true,
				},
			],
		},
		{
			name: 'page-dealers-projects',
			path: 'dealers/:name/:id/projects',
			meta: {
				title: 'Proyectos',
				primary: true,
			},
			props: true,
			component: () => import('@/pages/configuration/page-dealers-projects'),
			children: [
				{
					name: 'assignment-master-companies',
					path: ':codeProject/assignment-master-companies',
					component: () => import('@/pages/configuration/page-master-companies'),
					props: true,
				},
			],
		},
	],
};

export default route;




// WEBPACK FOOTER //
// ./src/router/configuration.js